import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {useQueryState} from 'iss/hooks/useQueryState';
import {searchForms} from 'iss/service/FormService';
import {hasAdminRole, hasExtAdminRole} from 'iss/service/PartyService';
import {EditButton, NewButton} from 'iss/widgets/Buttons';
import {translateFormEvaluationContext} from 'iss/widgets/domainTranslations';
import {FlexItem, FlexRow} from 'iss/widgets/Flex';
import {PagedSearchResults, SearchResultScroller, ShowAllResultsButton, TextSearchBar, formatResultCount} from 'iss/widgets/PagedSearchResults';
import {toOptions} from 'iss/widgets/Selectors';
import BootstrapSelect from 'iss/widgets/bootstrap/Select';

function FormList() {
  const [search, setSearch] = useQueryState({
    defaults: {query: "", context: 'QUALITY_ASSURANCE'}
  });

  return <div>
    <h1>{translate('formList.title')}</h1>
    <FormSearch search={search} onChange={setSearch} />
    <PagedSearchResults getItems={searchForms} search={search}>
      {(results, resultApi) =>
        <SearchResultScroller searchResult={results} onLoadMore={resultApi.loadMoreItems}>
          <FlexRow alignItems="center" flexAllChildren>
            <FlexItem>
              {formatResultCount(results)}
              <ShowAllResultsButton searchResult={results} onShowAll={resultApi.loadAllItems} />
            </FlexItem>
            <FlexItem flex="none">
              { hasAdminRole() && <NewButton id="new-form" link="/forms/new" text={translate('formList.newForm')} /> }
            </FlexItem>
          </FlexRow>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{translate('formList.formName')}</th>
                <th>{translate('formList.formDescription')}</th>
                <th>{translate('common.edit')}</th>
              </tr>
            </thead>
            <tbody>
              {R.defaultTo([], results.results).map(form => <FormListRow key={form.id} form={form} />)}
            </tbody>
          </table>
        </SearchResultScroller>
      }
    </PagedSearchResults>
  </div>;
}

function FormListRow({form}) {
  return <tr data-form-id={form.id}>
    <td className="form-name">{form.name}</td>
    <td className="form-description">{form.description}</td>
    <td>
      <EditButton className="modify-form" disabled={!hasAdminRole() && !hasExtAdminRole()}
        id={"modify-form-"+form.id}
        link={"/forms/"+form.id} alt={translate('formList.editFormTooltip')} />
    </td>
  </tr>;
}

function FormSearch({search, onChange}) {
  const {query, context} = search;

  const options = toOptions(
    translateFormEvaluationContext,
    ['QUALITY_ASSURANCE', 'WORK_SECURITY', 'OTHER']
  );

  return <TextSearchBar id="form-search" search={query}
    onChange={(newQuery) => onChange({context, query: newQuery})}>
    <BootstrapSelect id="formEvaluationContext" options={options} style={{minWidth: "20em"}} clearable={false}
      onChange={({value}) => onChange({query, context: value})}
      value={context}
    />
  </TextSearchBar>;
}

export default FormList;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/FormList.jsx